import { render, staticRenderFns } from "./ViaLocations.vue?vue&type=template&id=bb6a0f5c&scoped=true&"
import script from "./ViaLocations.vue?vue&type=script&lang=js&"
export * from "./ViaLocations.vue?vue&type=script&lang=js&"
import style0 from "./ViaLocations.vue?vue&type=style&index=0&id=bb6a0f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6a0f5c",
  null
  
)

/* custom blocks */
import block0 from "./ViaLocations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports